<template>
  <div>
    <div class="text-subtitle-2 sub-header my-3 primary--text text-uppercase">
      <v-icon v-if="icon" style="margin-top: -4px;" left size="36" color="primary">{{ icon }}</v-icon>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubHeader",
  props: {
    icon: String,
  }
}
</script>

<style lang="scss" scoped>
</style>
